import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { GALLERY_CATEGORIES, GALLERY_ITEMS } from "@/data/content";

export const GalleryGrid = ({ preview = false }) => {
  const [filter, setFilter] = useState("All");
  const [lightboxIndex, setLightboxIndex] = useState(-1);

  const filtered = (filter === "All" ? GALLERY_ITEMS : GALLERY_ITEMS.filter((i) => i.category === filter));
  const items = preview ? filtered.slice(0, 6) : filtered;

  return (
    <div data-testid="gallery-grid">
      {!preview && (
        <div className="flex flex-wrap gap-3 mb-12" data-testid="gallery-filters">
          {GALLERY_CATEGORIES.map((cat) => (
            <button
              key={cat}
              data-testid={`gallery-filter-${cat.toLowerCase()}`}
              onClick={() => setFilter(cat)}
              className={`px-5 py-2.5 rounded-full text-sm font-medium transition-[background-color,color,border-color] duration-300 border ${
                filter === cat
                  ? "bg-[#00E5FF] text-black border-[#00E5FF]"
                  : "bg-transparent text-[#A1A1A6] border-white/15 hover:border-[#00E5FF]/50 hover:text-[#F5F5F7]"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>
      )}

      <motion.div layout className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        <AnimatePresence mode="popLayout">
          {items.map((item, idx) => (
            <motion.button
              layout
              key={item.src}
              initial={{ opacity: 0, scale: 0.94 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.94 }}
              transition={{ duration: 0.4 }}
              data-testid={`gallery-item-${idx}`}
              onClick={() => setLightboxIndex(idx)}
              className="group relative overflow-hidden rounded-2xl border border-white/5 aspect-[4/3] text-left"
            >
              <img
                src={item.src}
                alt={`${item.title} — sample ${item.category} metal print`}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <div className="absolute bottom-0 inset-x-0 p-5 translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-[transform,opacity] duration-500">
                <p className="text-xs uppercase tracking-[0.2em] text-[#00E5FF] font-semibold">{item.category}</p>
                <p className="text-[#F5F5F7] font-medium mt-1">{item.title}</p>
              </div>
              <span className="absolute top-3 right-3 text-[10px] uppercase tracking-widest bg-black/60 backdrop-blur-md text-[#A1A1A6] px-3 py-1 rounded-full">
                Sample
              </span>
            </motion.button>
          ))}
        </AnimatePresence>
      </motion.div>

      <Lightbox
        open={lightboxIndex >= 0}
        close={() => setLightboxIndex(-1)}
        index={lightboxIndex}
        slides={items.map((i) => ({ src: i.src, title: `${i.title} (${i.category})` }))}
      />
    </div>
  );
};
